<template>
    <v-container class="mx-10">
        <div class="d-flex justify-start align-center flex-row">
            <h2 class="text-left">{{ `${$t('library.search_result')}: ${query}` }}</h2>
            <v-btn icon fab color="primary" class="ml-auto" @click="$emit('clean-search')"
                ><v-icon>mdi-close</v-icon></v-btn
            >
        </div>
        <v-row v-if="!loading && errorMessage">
            <v-col cols="12">
                <p class="text-center font-size-36">{{ errorMessage }}</p>
            </v-col>
        </v-row>
        <v-row v-if="books.length && !errorMessage">
            <v-col
                :cols="someBooks(item.id) ? '5' : '2'"
                :class="`${classCard}`"
                v-for="(item, i) in books"
                :key="i"
            >
                <book-card-pop-up
                    @cardPopUp="setCardPopup($event, item.id)"
                    :title="item.title"
                    :rating="item.rating"
                    :description="item.bookAbstract"
                    :imageSource="item.resourceDir"
                    :book_id="item.id"
                />
            </v-col>
        </v-row>
        <v-row v-if="loading">
            <v-col cols="2">
                <v-skeleton-loader height="300px" width="100%" type="image" />
            </v-col>
            <v-col cols="2">
                <v-skeleton-loader height="300px" width="100%" type="image" />
            </v-col>
            <v-col cols="2">
                <v-skeleton-loader height="300px" width="100%" type="image" />
            </v-col>
            <v-col cols="2">
                <v-skeleton-loader height="300px" width="100%" type="image" />
            </v-col>
            <v-col cols="2">
                <v-skeleton-loader height="300px" width="100%" type="image" />
            </v-col>
            <v-col cols="2">
                <v-skeleton-loader height="300px" width="100%" type="image" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import BookCardPopUpVue from './BookCardPopUp.vue'
export default {
    name: 'BookSearchContent',
    props: {
        books: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        errorMessage: { type: [String, Boolean], default: '' },
        query: { type: String, default: '' },
    },
    components: {
        'book-card-pop-up': BookCardPopUpVue,
    },
    data: () => ({
        booksActive: [],
    }),
    computed: {
        classCard() {
            if (this.cardPopUp) {
                return 'pop-up-enabled'
            }
            return 'pop-up-disabled'
        },
    },
    methods: {
        setCardPopup($event, id) {
            this.cardPopUp = false
            if ($event) {
                this.cardPopUp = $event
                this.booksActive = [...this.booksActive, id]
            } else {
                this.booksActive = this.booksActive.filter((i) => i !== id)
            }
        },
        someBooks(id) {
            return this.booksActive.some((i) => i === id)
        },
    },
}
</script>
